import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { Pill, LogIn } from "lucide-react";

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    const res = await login(email, password);
    setSubmitting(false);
    if (res.ok) {
      toast.success("Bienvenido de nuevo");
      const dest = location.state?.from || "/";
      navigate(dest, { replace: true });
    } else {
      toast.error(res.error || "No se pudo iniciar sesión");
    }
  };

  return (
    <div className="min-h-[80vh] grid place-items-center px-4 py-10 bg-slate-50">
      <Card className="w-full max-w-md p-7 sm:p-8 rounded-2xl shadow-lg border border-slate-200 bg-white">
        <div className="flex items-center gap-3 mb-1">
          <div className="h-11 w-11 rounded-xl bg-blue-600 grid place-items-center text-white shadow">
            <Pill className="w-5 h-5" />
          </div>
          <div>
            <h1 className="font-display text-2xl font-semibold text-slate-900">Iniciar sesión</h1>
            <p className="text-sm text-slate-500">Bienvenido a Medicamentos_CiudadEnfermeria</p>
          </div>
        </div>

        <form onSubmit={onSubmit} className="mt-5 space-y-4">
          <div>
            <Label htmlFor="email" className="text-sm font-medium text-slate-700">Correo</Label>
            <Input
              id="email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="tu@correo.com"
              className="h-12 mt-1.5 text-base bg-slate-50 focus:bg-white"
              data-testid="login-email-input"
            />
          </div>
          <div>
            <Label htmlFor="password" className="text-sm font-medium text-slate-700">Contraseña</Label>
            <Input
              id="password"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              className="h-12 mt-1.5 text-base bg-slate-50 focus:bg-white"
              data-testid="login-password-input"
            />
          </div>
          <Button
            type="submit"
            disabled={submitting}
            className="w-full h-13 h-14 text-base bg-blue-600 hover:bg-blue-700 rounded-xl btn-press shadow"
            data-testid="login-submit-btn"
          >
            <LogIn className="w-5 h-5 mr-2" />
            {submitting ? "Entrando…" : "Entrar"}
          </Button>
        </form>

        <p className="mt-5 text-sm text-center text-slate-600">
          ¿No tienes cuenta?{" "}
          <Link to="/register" className="text-blue-700 font-medium hover:underline" data-testid="login-go-register">
            Crear una cuenta
          </Link>
        </p>
      </Card>
    </div>
  );
}
